// ======================================================================
// File: src/modules/ipe/dashboard/crm/components/CRMActivityTimeline.jsx
// Purpose:
// CRM Live Activity Timeline
// ======================================================================

import React from "react";

export default function CRMActivityTimeline({
  activities = [],
}) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "18px",
        boxShadow: "0 2px 10px rgba(0,0,0,.06)",
        border: "1px solid #e5e7eb",
      }}
    >
      <h3
        style={{
          marginTop: 0,
          marginBottom: "18px",
          fontSize: "18px",
          fontWeight: 700,
        }}
      >
        Recent Activities
      </h3>

      {activities.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap: "14px",
            marginBottom: "16px",
          }}
        >
          <div
            style={{
              width: "12px",
              height: "12px",
              marginTop: "6px",
              borderRadius: "50%",
              background: item.color,
              flexShrink: 0,
            }}
          />

          <div style={{ flex: 1 }}>
            <div
              style={{
                fontWeight: 600,
                color: "#111827",
                fontSize: "14px",
              }}
            >
              {item.title}
            </div>

            <div
              style={{
                color: "#64748b",
                fontSize: "12px",
                marginTop: "2px",
              }}
            >
              {item.time}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}